import PropTypes from 'prop-types'
import styled from 'styled-components'

import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'
import CreatedClosedTicketsPieChart from './CreatedClosedTicketsPieChart'
import LoadingIndicator from 'components/Shared/LoadingIndicator/Index'
import Tooltip from 'components/Shared/Tooltip/Index'
import IconLink from 'components/Shared/IconLink/Index'

const StyledContent = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-right: 8px;
  background-color: #fff;
  padding: 10px 16px 10px 16px;
  box-sizing: border-box;
  border-radius: 3px;
`
const Title = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 10px;
  color: ${colors.secondary20};
`

const ChartsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-self: center;
`

const CreatedClosedChart = ({
  recentNewTicketsCount, recentClosedTicketsCount,
  isFetching,
}) => {
  const { t } = useTranslation()

  const tooltipText = t('dashboardPage.createdVsClosedTooltip')
  const tooltipId = 'create-closed-tooltip'

  return (
    <StyledContent data-test='created-closed-chart'>
      <LoadingIndicator loading={isFetching} small />
      <Title>
        {t('dashboardPage.createdVsClosed')}
        <IconLink
          data-tooltip-content={tooltipText}
          data-tooltip-id={tooltipId}
          iconName='icon-help-16'
        />
        <Tooltip id='create-closed-tooltip' />
      </Title>
      <ChartsWrapper>
        <CreatedClosedTicketsPieChart
          recentNewTicketsCount={recentNewTicketsCount}
          recentClosedTicketsCount={recentClosedTicketsCount}
        />
      </ChartsWrapper>
    </StyledContent>
  )
}

CreatedClosedChart.propTypes = {
  recentNewTicketsCount: PropTypes.number,
  recentClosedTicketsCount: PropTypes.number,
  isFetching: PropTypes.bool,
}

export default CreatedClosedChart
